module.exports = __webpack_public_path__ + "f3334580ddbca9007f98faae6f7d65e3.MP3";